import { render, staticRenderFns } from "./PaymentLinkOverlay.vue?vue&type=template&id=2edb0132&scoped=true&"
import script from "./PaymentLinkOverlay.vue?vue&type=script&lang=ts&"
export * from "./PaymentLinkOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentLinkOverlay.vue?vue&type=style&index=0&id=2edb0132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb0132",
  null
  
)

export default component.exports